import { isEmpty } from 'lodash'
import React, { FunctionComponent, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { OnDemandGallery } from '../../components/OnDemandGallery'
import { CurrentUserType } from '../../ducks/auth'
import Amplitude from '../../utils/amplitudeHelper'
import { PageStyle } from './styled'
import { desktopAssets, fixedAssets } from 'src/containers/PreCache'

interface DesktopOnDemandTypes {
  currentUser: CurrentUserType
}

const DesktopOnDemand: FunctionComponent<DesktopOnDemandTypes> = ({ currentUser }) => {
  const history = useHistory()
  const { pageTitle, previousPagePath } = useSelector((state) => state.onDemand)

  useEffect(() => {
    if (pageTitle.length > 0) Amplitude.visit(pageTitle)
  }, [currentUser.id, pageTitle])

  const goBack = () => {
    if (isEmpty(previousPagePath)) {
      history.goBack()
    } else {
      history.push(previousPagePath)
    }
  }

  return (
    <PageStyle>
      <section className="page-layout">
        <div className="page-sidebar">
          <img src={desktopAssets.gallerySidebarBg} className='px-2' alt="event kv" />
          
          {/* <div className="intro">
            <img src={desktopAssets.galleryMasthead} width="100%" className='px-2' alt="event kv" />
            <div className='page-title'>
              <h2>{pageTitle}</h2>
            </div>
          </div> */}
        </div>
        <div className="page-content">
          <header onClick={goBack} className='d-flex back-btn align-items-center justify-content-start px-3 py-3 ' style={{ marginBlock: '3rem'}}>
            <span style={{ cursor: 'pointer', width: '100%', maxWidth: '150px', fontWeight: 700, marginBlock: '4px', fontSize: '1rem' }} className="btn c-button d-flex align-items-center justify-content-center">Back</span>
          </header>

          <OnDemandGallery />
        </div>
      </section>
    </PageStyle>
  )
}

export default DesktopOnDemand